module.exports = __webpack_public_path__ + "img/img_jf.92a69d85.jpg";